import {
  PERMISSION_ACCESS_LEVEL_CHART,
  PERMISSION_ACCESS_CONSUMPTION_CHART,
  PERMISSION_ACCESS_LEVEL_REPORT,
  PERMISSION_ACCESS_CONSUMPTION_HISTORY,
  PERMISSION_ACCESS_LEVEL_HISTORY,
  PERMISSION_ACCESS_ALL_INSTALLATIONS,
  PERMISSION_ACCESS_TRIP_HISTORY,
} from "../models/Permission";

const WMInternalAccessPermission = [
  PERMISSION_ACCESS_LEVEL_CHART,
  PERMISSION_ACCESS_CONSUMPTION_CHART,
  PERMISSION_ACCESS_LEVEL_REPORT,
  PERMISSION_ACCESS_CONSUMPTION_HISTORY,
  PERMISSION_ACCESS_LEVEL_HISTORY,
  PERMISSION_ACCESS_ALL_INSTALLATIONS,
  PERMISSION_ACCESS_TRIP_HISTORY,
];

export default WMInternalAccessPermission;
